import axios from "axios";
import React, { useRef, useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import css from "../css/Addcase.module.css";
import Compressor from "compressorjs";
import css1 from "../css/Pan.module.css";
import Rightcontainer from "../Components/Rightcontainer";
import "../css/Loader.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "../css/viewGame1.css";
import "../css/layout.css";
import Swal from "sweetalert2";
import Header from "../Components/Header";
import socket from "../Components/socket";
import "../css/landing.css";
import Modal from "react-bootstrap/Modal";
import { BsArrowRight, BsQrCodeScan } from "react-icons/bs";
import DownloadLink from "react-download-link";
import Spinner from "react-bootstrap/Spinner";
import SabpaisaPaymentGateway from "./SabpaisaPaymentGateway";
import { apiRequest } from "../store/allApi";
import { height } from "@mui/system";

const Addcase = ({ walletUpdate }) => {
  // BASE URL

  const baseUrl = process.env.REACT_APP_API_BASE_URL;

  // +++++++++++++++++++++++++++++
  const [userAllData, setUserAllData] = useState();

  const userData = localStorage.getItem("udata");
  const udata = JSON.parse(userData);

  const phone = localStorage.getItem("phone");

  const [clientCode, setClientCode] = useState("RALY03");
  const [transUserName, setTransUserName] = useState("kingtox41232323_15556");
  const [transUserPassword, setTransUserPassword] = useState("RALY03_SP15556");
  const [authkey, setAuthkey] = useState("b5gF6mGKDHicH6WB");
  const [authiv, setAuthiv] = useState("wD6KKUsCumUEeogG");

  // sabpay
  // alert(udata.Name.replace(/[^a-zA-Z0-9]/g,''))
  const [payerName, setPayerName] = useState(
    udata.Name?.replace(/[^a-zA-Z0-9]/g, ""),
  );
  const [payerEmail, setPayerEmail] = useState(udata.Email);
  const [payerMobile, setPayerMobile] = useState(phone);

  const [clientTxnId, setclientTxnId] = useState(null);

  const [payerAddress, setPayerAddress] = useState("Kolkata");
  const [callbackUrl, setCallbackUrl] = useState("/sabpaisaGateway");

  const [isOpen, setIsOpen] = useState(false);

  const history = useHistory();
  let method = useRef();
  let checkInterval;

  const access_token = localStorage.getItem("token");

  const [isLoading1, setIsloading1] = useState(false);
  const [global, setGlobal] = useState(10.0);
  const [next, setNext] = useState(1);
  const [process1, setProcess] = useState(false);
  const [isMobile, setMobile] = useState(false);

  const [isCashFreeActive, setCashFreeActive] = useState(true);
  const [isPhonePayActive, setIsPhonePayActive] = useState(false);
  const [isAirPayActive, setIsAirPayActive] = useState(false);
  const [isMypayInActive, setIsMyPayActive] = useState(false);
  const [isUpiGateway, setisUpiGateway] = useState(false);
  const [AcDeposit, setAcDeposit] = useState(false);
  const [manualDeposit, setManualDeposit] = useState(false);
  const [isPineLabActive, setPineLabActive] = useState(false);
  const [isRazorPayActive, setRazorPayActive] = useState(false);
  const [isDecentroActive, setDecentroActive] = useState(false);
  const [isHoadaPaypayInActive, setHoadaPaypayInActive] = useState(false);
  const [ManualPaymentdata, setManualPaymentdata] = useState([]);
  const [isSubPaisaActive, setIsSubPaisaActive] = useState(false);

  const [manualData, setManualData] = useState([]);
  const [PayOneImage, setPayOneImage] = useState("");
  const [PayTwoImage, setPayTwoImage] = useState("");
  const [PayThreeImage, setPayThreeImage] = useState("");
  const [PayFourImage, setPayFourImage] = useState("");
  const [PayFiveImage, setPayFiveImage] = useState("");

  // hooks for payment url
  const [PayNow1Url, setPaynow1Url] = useState("");
  const [PayNow2Url, setPaynow2Url] = useState("");
  const [PayNow3Url, setPaynow3Url] = useState("");
  const [PayNow4Url, setPaynow4Url] = useState("");
  const [PayNow5Url, setPaynow5Url] = useState("");

  const [show_won, setShow_won] = useState(false);
  const handleClose_won = () => setShow_won(false);
  const [scrnshot, setScrnshot] = useState(null);
  const [fecthStatus, setFecthStatus] = useState();
  const [scrnshot1, setScrnshot1] = useState("");
  const handleShow_won = () => setShow_won(true);

  const [qrCode, setQrCode] = useState();
  const [walletOption, setWalletOption] = useState("airtel");
  const [bankCode, setBankCode] = useState(3003);

  const [account_mail_id, setAccount_mail_id] = useState();
  const [account_name, setAccount_name] = useState();
  const [accountPhone, setAccountPhone] = useState();
  const [isLoading, setIsLoading] = useState(false);

  const [minLimit, setMinLimit] = useState(null);
  const [maxLimit, setMaxLimit] = useState(null);
  const [amount, setamount] = useState("");
  const [utr, setutr] = useState("");

  // console.log(maxLimit)

  const addsetting = localStorage.getItem("sitSetting");
  const addCaseSetting = JSON.parse(addsetting);

  // Hoada Hooks

  const [hoadaPay, setHoadaPay] = useState(false);

  const detail = localStorage.getItem("");

  useEffect(() => {
    setMinLimit(addCaseSetting.depositlimitMin);
    setMaxLimit(addCaseSetting.depositlimitMax);

    // if (!addCaseSetting?.isDeposit) {
    //   document.getElementById("addcase").style.display = "none";
    //   document.getElementById("depositClose").style.display = "block";
    // }
  }, []);
  // useEffect(() => {
  //   setMinLimit(addCaseSetting.depositlimitMin);
  //   setMaxLimit(addCaseSetting.depositlimitMax);
  //   setIsDeposit(addCaseSetting?.isDeposit);
  // }, [addCaseSetting]);

  const handleNext = () => {
    if (udata?.verified !== "verified") {
      Swal.fire({
        title: "Complete your KYC",
        text: "कृपया 👉 Deposit add करने से पहले KYC कम्पलीट करें 🙏",
        icon: "warning",
        confirmButtonText: "Go to Profile",
        showCancelButton: true,
        cancelButtonText: "Cancel",
      }).then((result) => {
        if (result.isConfirmed) {
          history.push("/profile");
        }
      });
      return;
    }

    if (global < minLimit || global > maxLimit) {
      Swal.fire(
        `Minimum amount should be greater than ${minLimit} and maximum amount should be less than ${maxLimit}`,
      );
      return;
    }

    setNext(2);
  };

  //Function to load razorpay script for the display of razorpay payment SDK.
  function loadRazorpayScript(src) {
    return new Promise((resolve) => {
      const script = document.createElement("script");
      script.src = src;
      script.onload = () => {
        resolve(true);
      };
      script.onerror = () => {
        resolve(false);
      };
      document.body.appendChild(script);
    });
  }

  //function will get called when clicked on the pay button.
  async function displayRazorpayPaymentSdk(
    channel,
    method,
    upiMethod,
    razorpay,
  ) {
    const res = await loadRazorpayScript(
      "https://checkout.razorpay.com/v1/checkout.js",
    );

    if (!res) {
      alert("Razorpay SDK failed to load. please check are you online?");
      return;
    }
    //setProcess(true);
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };
    // creating a new order and sending order ID to backend
    const response = await axios.post(
      baseUrl + "user/razorpay_order",
      {
        amount: global,

        channel: channel,
        payment_method: method,
        provider: walletOption,
        bankCode: bankCode,
        account_name: account_name,
        payment_gatway: razorpay,
      },
      { headers },
    );
    if (!response) {
      alert("Server error. please check are you onlin?");
      return;
    }

    // Getting the order details back
    let order_id = response.data.txnID;
    let order_token = response.data.orderdata.id;
    const data = response.data.orderdata;
    const options = {
      key: "rzp_live_hmxBSXgEqtBqJq",
      name: "Rk Ludo",
      description: "Skill Based Game Tournament",
      order_id: data.id,
      prefill: {
        name: account_name,
        email: account_mail_id,
        contact: accountPhone,
      },
      handler: async (response) => {
        //console.log(response)
        try {
          const paymentId = response.razorpay_payment_id;

          checkrazorpaydeposit(order_id, order_token, "SUCCESS", paymentId);
        } catch (err) {
          checkrazorpaydeposit(order_id, order_token, "FAILED");
          console.log(err);
        }
      },
      theme: {
        color: "#686CFD",
      },
    };

    const paymentObject = new window.Razorpay(options);
    paymentObject.open();
  }

  const checkrazorpaydeposit = async (
    order_id,
    order_token,
    order_status,
    paymentId,
  ) => {
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    try {
      const res = await apiRequest(
        "razorpaydesposit/response",
        "POST",
        { order_id, order_token, order_status, paymentId },
        headers,
      );
      const icon = res.data.status == "PAID" ? "success" : "danger";
      const title =
        res.data.status == "PAID"
          ? "Deposit submited successfully"
          : "Transaction Failed";
      history.push("/");
      setTimeout(() => {
        Swal.fire({
          title: title,
          icon: icon,
          confirmButtonText: "OK",
        });
      }, 1000);
    } catch (e) {
      if (e.response.status == 401) {
        localStorage.removeItem("token");
        localStorage.removeItem("token");
        localStorage.removeItem("phone");
        window.location.reload();
      }
    }
    // axios
    //   .post(
    //     baseUrl + `razorpaydesposit/response`,
    //     { order_id, order_token, order_status, paymentId },
    //     { headers }
    //   )
    //   .then((res) => {

    //   })
    //   .catch((e) => {

    //   });
  };

  // PHONEPAY GETWAY API

  const fetchPaymentUrl = async () => {
    try {
      setIsLoading(true);

      const response = await fetch(
        baseUrl + `phonpay-request?amount=${global}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${access_token}`,
          },
        },
      );

      const data = await response.json();
      if (data) {
        setIsLoading(false);

        window.location.href = data.data.instrumentResponse.redirectInfo.url;
      }
    } catch (error) {
      console.error("Error fetching payment URL:", error);
      setIsLoading(false);
    }
  };
  // upigateway

  const upigateway = async () => {
    setProcess(true);
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    try {
      const res = await apiRequest(
        "pg-upigateway",
        "POST",
        { amount: global },
        headers,
      );
      if (res.data.data?.status) {
        setProcess(false);
        window.open(res.data.data?.result?.payment_url);
        setTimeout(() => {
          setProcess(false);
        }, 60000);
      } else {
        setProcess(false);
        Swal.fire({
          title: res.data.data.msg,
          icon: "danger",
          confirmButtonText: "OK",
        });
      }
    } catch (e) {
      alert(e);
    }
    // axios
    //   .post(
    //     baseUrl + `upigateway/deposite`,
    //     {
    //       amount: global,
    //     },
    //     { headers }
    //   )
    //   .then((res) => {

    //   })
    //   .catch((e) => {

    //   });
  };

  // pgupigateway

  const pgupigateway = () => {
    setProcess(true);
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };
    axios
      .post(
        baseUrl + `/pg-upigateway?amount=${global.toFixed(2)}`,
        {
          amount: global,
        },
        { headers },
      )
      .then((res) => {
        console.log(res.data.data.result, "sdsd");
        if (res.data.data.result) {
          // console.log(res.data.data.data.payment_url)
          // console.log(res.data.data.data.order_id)
          // let order_id = res.data.txnID
          // let order_token = res.data.data.data.order_id
          //setProcess(false);
          window.open(res.data.data.result.payment_url);
          setTimeout(() => {
            // checkupideposit(order_id, order_token)
            setProcess(false);
          }, 60000);
        } else {
          setProcess(false);
          Swal.fire({
            title: res.data.data.msg,
            icon: "danger",
            confirmButtonText: "OK",
          });
        }
      })
      .catch((e) => {
        alert(e);
      });
  };

  // HOADA PAY GETWAY API
  const Hoada = async () => {
    try {
      setIsLoading(true);

      const response = await fetch(
        baseUrl + `haodapay-request-payin?amount=${global}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${access_token}`,
          },
        },
      );

      const data = await response.json();
      if (data) {
        setTimeout(() => {
          setIsLoading(false);
        }, 5000);

        const isMobile = window.innerWidth < 768;

        if (isMobile) {
          //  window.location.href = data.data.data.intent_link;
          window.location.href = data.data.data.payment_link;
        } else {
          window.location.href = data.data.data.payment_link;
        }
      }
    } catch (error) {
      console.error("Error fetching payment URL:", error);
      setIsLoading(false);
    }
  };

  // MYPAY GETWAY API
  // const myPay = async () => {
  //   try {
  //     setIsLoading(true);

  //     const response = await fetch(
  //       baseUrl + `mypay/payin?amount=${global}`,
  //       {
  //         method:'POST',
  //         headers: {
  //           "Content-Type": "application/json",
  //           Authorization: `Bearer ${access_token}`,
  //         },
  //       }
  //     );

  //     const data = await response.json();
  //     if (data) {
  //       setIsLoading(false);
  //       console.log(data);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching payment URL:", error);
  //     setIsLoading(false);
  //   }
  // };

  const myPay = async () => {
    setProcess(true);
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    try {
      const res = await apiRequest(
        `kvmpay/payin`,
        "POST",
        { amount: global },
        headers,
      );
      console.log(res, "res");
      setProcess(false);
      if (res.data.status == false) {
        Swal.fire({
          title: res.data.msg,
          icon: "danger",
          confirmButtonText: "OK",
        });
      } else if (res.data) {
        let order_id = res.data.txnID;
        let order_token = res.data.paymentReferenceId;
        //setProcess(false);
        window.open(`${res?.data?.qrcodE_STRING}&am=${global}`);
        setTimeout(() => {
          checkupideposit(order_id, order_token);
          setProcess(false);
        }, 30000);
      } else {
        setProcess(false);
        Swal.fire({
          title: res.data.status,
          icon: "danger",
          confirmButtonText: "OK",
        });
      }
    } catch (e) {
      setProcess(false);
      console.log(e, "error");

      if (e.response.status == 400 || e.response.status == 429) {
        Swal.fire({
          title: e.response?.data.msg,
          icon: "warning",
          confirmButtonText: "OK",
        });
      } else {
        Swal.fire({
          title: "error!! Please refresh and connect to admin",
          icon: "warning",
          confirmButtonText: "OK",
        });
      }
      alert(e);
    }
    // axios
    //   .post(
    //     baseUrl + `kvmpay/payin`,
    //     {
    //       amount: global,
    //     },
    //     { headers }
    //   )
    //   .then((res) => {

    //   })
    //   .catch((e) => {

    //   });
  };

  // sab pay
  const fetchPaymentUrl2 = async (e) => {
    // setPayerName(userData.Name)
    console.log(userData?.Name);

    setProcess(true);
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    try {
      const res = await apiRequest(
        `subpaisa/pay`,
        "POST",
        { amount: global },
        headers,
      );
      console.log(res.data, "res");
      setProcess(false);
      var resp = res.data;
      if (resp.status === false) {
        Swal.fire({
          title: res.data.msg,
          icon: "danger",
          confirmButtonText: "OK",
        });
      } else {
        setclientTxnId(resp.data.referenceId);
        setProcess(false);
        setIsOpen(true);
        const btn = document.getElementById("renderSabPaisa");
        btn.click();
      }
    } catch (e) {
      setProcess(false);

      if (e.response?.status == 400 || e.response?.status == 429) {
        Swal.fire({
          title: e.response.data.msg,
          icon: "warning",
          confirmButtonText: "OK",
        });
      } else {
        Swal.fire({
          title: "error!! Please refresh and connect to admin",
          icon: "warning",
          confirmButtonText: "OK",
        });
      }
    }
    // await axios
    //   .post(
    //     baseUrl + `subpaisa/pay`,
    //     {
    //       amount: global,
    //     },
    //     { headers }
    //   )
    //   .then((res) => {

    //   })
    //   .catch((e) => {

    //   });

    const btn = document.getElementById("renderSabPaisa");
    if (btn) {
      btn.click();
    }
    // history.push('/sabpaisaGateway')
  };

  const checkupideposit = async (order_id, order_token) => {
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    try {
      const res = await apiRequest(
        `depositupipay/response`,
        "POST",
        { order_id, order_token },
        headers,
      );
      const icon = res.data.status == "PAID" ? "success" : "danger";
      const title =
        res.data.status == "PAID"
          ? "Deposit submited successfully"
          : "Transaction Failed";
      history.push("/");
      setTimeout(() => {
        Swal.fire({
          title: title,
          icon: icon,
          confirmButtonText: "OK",
        });
      }, 1000);
    } catch (e) {
      if (e.response.status == 401) {
        localStorage.removeItem("token");
        localStorage.removeItem("token");
        window.location.reload();
      }
    }
    // axios
    //   .post(
    //     baseUrl + `depositupipay/response`,
    //     { order_id, order_token },
    //     { headers }
    //   )
    //   .then((res) => {

    //   })
    //   .catch((e) => {

    //   });
  };

  //use for cashfree gatway
  const deposit = async (channel, method, upiMethod) => {
    setProcess(true);
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };
    const data1 = {
      amount: global,
      channel: channel,
      payment_method: method,
      provider: walletOption,
      bankCode: bankCode,
    };

    try {
      const res = await apiRequest(`user/deposite`, "POST", data1, headers);
      if (res.data.data.payment_method == "app") {
        window.location.href = res.data.data.data.url;
        checkInterval = setInterval(
          (ID) => {
            checkout(ID);
          },
          10000,
          res.data.txnID,
        );
      } else if (
        res.data.data.channel == "link" &&
        res.data.data.payment_method == "upi"
      ) {
        checkInterval = setInterval(
          (ID) => {
            checkout(ID);
          },
          10000,
          res.data.txnID,
        );
        window.location.href = res.data.data.data.payload[upiMethod];
      } else if (
        res.data.data.channel == "qrcode" &&
        res.data.data.payment_method == "upi"
      ) {
        setQrCode(res.data.data.data.payload.qrcode);
        setProcess(false);
        setNext(3);
        checkInterval = setInterval(
          (ID) => {
            checkout(ID);
          },
          10000,
          res.data.txnID,
        );
      }
    } catch (e) {
      alert(e);
    }
    // axios
    //   .post(
    //     baseUrl + `user/deposite`,
    //     {
    //       amount: global,
    //       channel: channel,
    //       payment_method: method,
    //       provider: walletOption,
    //       bankCode: bankCode,
    //     },
    //     { headers }
    //   )
    //   .then((res) => {

    //   })
    //   .catch((e) => {

    //   });
  };

  const checkout = async (paymentID) => {
    socket.emit("getprofile");

    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    try {
      const res = await apiRequest(
        `checkout/deposite/txn`,
        "POST",
        { txnID: paymentID },
        headers,
      );
      if (res.data.txnStatus == "PAID") {
        walletUpdate();
        clearInterval(checkInterval);
        Swal.fire({
          title: res.data.msg,
          icon: "success",
          confirmButtonText: "OK",
        });

        setProcess(false);
        setNext(1);
        history.push("/");
      } else if (res.data.txnStatus == "FAILED") {
        walletUpdate();
        clearInterval(checkInterval);
        Swal.fire({
          title: res.data.msg,
          icon: "error",
          confirmButtonText: "OK",
        });

        setProcess(false);
        setNext(1);
      }
    } catch (e) {
      console.log(e);
    }
    // axios
    //   .post(
    //     baseUrl + `checkout/deposite/txn`,
    //     { txnID: paymentID },
    //     { headers }
    //   )
    //   .then((res) => {
    //     // alert(res.data.txnStatus)

    //   })
    //   .catch((e) => {

    //   });
  };

  useEffect(() => {
    // let access_token = localStorage.getItem("token");
    // const headers = {
    //   Authorization: `Bearer ${access_token}`,
    // };
    // axios
    //   .get(baseUrl + `me`, { headers })
    //   .then((res) => {

    //   })
    //   .catch((e) => {

    //   });

    // axios
    //   .get(baseUrl + `website/setting`)
    //   .then((res) => {

    //   })
    //   .catch((e) => {

    //   });

    // if (
    //   /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    //     navigator.userAgent
    //   )
    // ) {
    //   setMobile(true);
    // }

    me();
    website();
  }, []);

  const me = async () => {
    let access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };
    try {
      const res = await apiRequest("me", "GET", null, headers);
      setUserAllData(res.data);
      setAccount_mail_id(res.data.Email);
      setAccount_name(res.data.holder_name);
      setAccountPhone(res.data.Phone);
      setPayerMobile(res.data.Phone);
    } catch (e) {
      if (e.response?.status == 401) {
        localStorage.removeItem("token");
        localStorage.removeItem("token");
        window.location.reload();
        history.push("/login");
      }
    }
  };

  const website = async () => {
    let access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };
    try {
      const res = await apiRequest("website/setting", "GET", null, headers);
      console.log(res.data);
      setCashFreeActive(res.data.isCashFreeActive);
      setRazorPayActive(res.data.isRazorPayActive);
      setDecentroActive(res.data.isDecentroActive);
      setPineLabActive(res.data.isPineLabActive);
      setIsSubPaisaActive(res.data.isSubPaisaActive);

      setIsPhonePayActive(res.data.isPhonePayActive);
      setupi(res.data.upiId);
      setIsSubPaisaActive(res.data.isSubPaisaActive);
      setIsAirPayActive(res.data.isAirPayActive);
      setIsMyPayActive(res.data.isMypayInActive);
      setManualDeposit(res.data.manualDeposit);
      setHoadaPaypayInActive(res.data.isHaodaPayPayInActive);
    } catch (e) {
      setCashFreeActive(false);
      setRazorPayActive(false);
      setDecentroActive(false);
      setPineLabActive(false);
      setIsPhonePayActive(false);
      setIsAirPayActive(false);
      setIsMyPayActive(false);
      setAcDeposit(false);
    }
    if (
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent,
      )
    ) {
      setMobile(true);
    }
  };
  // QR CODE IMAGES DOWNLOAD ---------------------------------------------------

  const handleImageDownload = (item) => {
    const link = document.createElement("a");
    link.href = item;
    link.download = "QR-Code.png"; // You can specify the downloaded file name here
    link.click();
  };
  // clear Image
  const clearImage = (e) => {
    setScrnshot1(null);
    setScrnshot(null);
  };
  // MANUAL PAYMENTS METHODS API

  const handleChange = (e) => {
    setScrnshot1(URL.createObjectURL(e.target.files[0]));
    const image = e.target.files[0];
    if (image && image.size / 1000 > 300) {
      console.log(" compression");
      new Compressor(image, {
        quality: 0.6,
        success(compressedResult) {
          if (compressedResult) {
            setScrnshot(compressedResult);
          } else {
            setScrnshot(image);
          }
        },
      });
    } else {
      setScrnshot(e.target.files[0]);
    }
  };

  const ManualPayment = async () => {
    let access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    try {
      const res = await apiRequest(
        "gatewaysettings/data",
        "GET",
        null,
        headers,
      );
      const result = res.data;
      if (result) {
        setManualData(result);
        setAcDeposit(result?.AcDeposit);
        setPayOneImage(result?.isPayOneImage);
        setPayTwoImage(result?.isPayTwoImage);
        setPayThreeImage(result?.isPayThreeImage);
        setPayFourImage(result?.isPayFourImage);
        setPayFiveImage(result?.isPayFiveImage);
        setisUpiGateway(result?.isUpiGateway);
      }
    } catch (error) {
      console.log("error", error);
    }

    // var requestOptions = {
    //   method: "GET",
    //   headers: myHeaders,
    //   redirect: "follow",
    // };

    // fetch(baseUrl + "gatewaysettings/data", requestOptions)
    //   .then((response) => response.json())
    //   .then((result) => {
    //     setManualData(result);
    //     setAcDeposit(result?.AcDeposit);
    //     setPayOneImage(result?.isPayOneImage);
    //     setPayTwoImage(result?.isPayTwoImage);
    //     setPayThreeImage(result?.isPayThreeImage);
    //     setPayFourImage(result?.isPayFourImage);
    //     setPayFiveImage(result?.isPayFiveImage);
    //     setisUpiGateway(result?.isUpiGateway);
    //   })
    //   .catch((error) => {
    //     console.log("error", error);
    //   });
  };

  useEffect(() => {
    ManualPayment();
  }, []);

  // getImage URl
  const [ImageUrl, setImageUrl] = useState("");
  const [PaymentLink, setPaymentLink] = useState("");
  const [upi, setupi] = useState("");

  const getImageUrl = (image, url) => {
    setImageUrl(image);
    setPaymentLink(url);
  };

  // code link payment

  const copyCode = (e) => {
    navigator.clipboard.writeText(manualData.isPayOneUpi);

    Swal.fire({
      position: "center",
      icon: "success",
      type: "success",
      title: "Upi Copied",
      showConfirmButton: false,
      timer: 1200,
    });
  };
  const copyBank = (e) => {
    navigator.clipboard.writeText(manualData?.BankName);

    Swal.fire({
      position: "center",
      icon: "success",
      type: "success",
      title: "Bank Name Copied",
      showConfirmButton: false,
      timer: 1200,
    });
  };
  const copyUpi = (e) => {
    navigator.clipboard.writeText(manualData?.isPayTwoUpi);

    Swal.fire({
      position: "center",
      icon: "success",
      type: "success",
      title: "UPI ID Copied",
      showConfirmButton: false,
      timer: 1200,
    });
  };
  const copyUpiAc = (e) => {
    navigator.clipboard.writeText(manualData?.upiIdAccount);

    Swal.fire({
      position: "center",
      icon: "success",
      type: "success",
      title: "UPI ID Copied",
      showConfirmButton: false,
      timer: 1200,
    });
  };
  const copyAcName = (e) => {
    navigator.clipboard.writeText(manualData?.holderName);

    Swal.fire({
      position: "center",
      icon: "success",
      type: "success",
      title: "Account Name Copied",
      showConfirmButton: false,
      timer: 1200,
    });
  };
  const copyAcNo = (e) => {
    navigator.clipboard.writeText(manualData?.acNO);

    Swal.fire({
      position: "center",
      icon: "success",
      type: "success",
      title: "Account Number Copied",
      showConfirmButton: false,
      timer: 1200,
    });
  };
  const copyIFSC = (e) => {
    navigator.clipboard.writeText(manualData?.IFSC);

    Swal.fire({
      position: "center",
      icon: "success",
      type: "success",
      title: "IFSC CODE Copied",
      showConfirmButton: false,
      timer: 1200,
    });
  };
  const copyButton = (e) => {
    navigator.clipboard.writeText(e);

    Swal.fire({
      position: "center",
      icon: "success",
      type: "success",
      title: "Copy SuccessFully",
      showConfirmButton: false,
      timer: 1200,
    });
  };

  const ManualPayments = async () => {
    setIsloading1(true);
    let access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    var formdata = new FormData();
    formdata.append("Transaction_Screenshot", scrnshot);
    formdata.append("amount", global);
    formdata.append("referenceId", utr);

    try {
      const result = await apiRequest(
        "manual/deposit/txn",
        "POST",
        formdata,
        headers,
      );

      console.log(result);

      if (result) {
        setIsloading1(false);

        if (result?.data?.status === "Pending") {
          Swal.fire({
            title: result?.data?.message,
            icon: "success",
            confirmButtonText: "OK",
          });
        } else {
          Swal.fire({
            title: result?.data?.message,
            icon: "error",
            confirmButtonText: "OK",
          });
        }
        history.push("/");
        handleClose_won();
      }
    } catch (error) {
      console.log("error", error);
    }

    // fetch(baseUrl + "manual/deposit/txn", requestOptions)
    //   .then((response) => response.json())
    //   .then((result) => {
    //     setIsloading1(false);

    //     if (result.status === "Pending") {
    //       Swal.fire({
    //         title: result.message,
    //         icon: "success",
    //         confirmButtonText: "OK",
    //       });
    //     } else {
    //       Swal.fire({
    //         title: result.message,
    //         icon: "error",
    //         confirmButtonText: "OK",
    //       });
    //     }
    //     history.push("/");
    //     handleClose_won();
    //   })

    //   .catch((error) => console.log("error", error));
  };
  const AccountPayment = async () => {
    setIsloading1(true);
    let access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    var formdata = new FormData();
    formdata.append("Transaction_Screenshot", scrnshot);
    formdata.append("amount", global);
    formdata.append("referenceId", utr);

    try {
      const result = await apiRequest(
        "manual/deposit/txn",
        "POST",
        formdata,
        headers,
      );
      if (result) {
        setIsloading1(false);

        if (result?.data?.status === "Pending") {
          Swal.fire({
            title: result?.data?.message,
            icon: "success",
            confirmButtonText: "OK",
          });
        } else {
          Swal.fire({
            title: result?.data?.message,
            icon: "error",
            confirmButtonText: "OK",
          });
        }
        history.push("/");
        handleClose_won();
      }
    } catch (error) {
      console.log("error", error);
    }
    // fetch(baseUrl + "manual/deposit/txn", requestOptions)
    //   .then((response) => response.json())
    //   .then((result) => {
    //     setIsloading1(false);

    //     if (result.status === "Pending") {
    //       Swal.fire({
    //         title: result.message,
    //         icon: "success",
    //         confirmButtonText: "OK",
    //       });
    //     } else {
    //       Swal.fire({
    //         title: result.message,
    //         icon: "error",
    //         confirmButtonText: "OK",
    //       });
    //     }
    //     history.push("/");
    //     handleClose_won();
    //   })

    //   .catch((error) => console.log("error", error));
  };

  const [paymentMethod, setPaymentMethod] = useState("");
  const [nextStep, setNextStep] = useState(null);

  // Handle selection change
  const handlePaymentMethodChange = (event) => {
    const selectedMethod = event.target.value;
    setPaymentMethod(selectedMethod);

    // Example logic to handle different options
    if (selectedMethod === "Account") {
      setNextStep(6); // Update the next step based on selection
    } else {
      setNextStep(7); // Reset or handle other cases
    }
  };

  return (
    <>
      <Header user={userAllData} />
      <div className="leftContainer bg-body pt-5 pb-5">
        <div className="mt-3 Orher_page_main_section">
          <div className="gameCard pt-0">
            {/* <div className='alrt_msg_div'>
                <h5 className=''>
                  {JSON.parse(localStorage.getItem('sitSetting')) == 'undefined'
                    ? ''
                    : JSON.parse(localStorage.getItem('sitSetting'))
                        ?.deposit_message}
                </h5>
              </div> */}
          </div>
          {Boolean(!process1) && (
            <div>
              {Boolean(next == 1) && (
                <div className="add-chips-container">
                  {/* Alert Message Box */}
                  <div className="status-alert-card">
                    <div className="alert-icon">
                      <i className="fa fa-info-circle"></i>
                    </div>
                    <div className="alert-text">
                      {JSON.parse(localStorage.getItem("sitSetting")) ==
                        "undefined"
                        ? "Loading..."
                        : JSON.parse(localStorage.getItem("sitSetting"))
                          ?.deposit_message}
                    </div>
                  </div>

                  <div className="amount-selection-card">
                    <h2 className="section-title">Enter Amount to Add</h2>

                    {/* Main Input Field */}
                    <div className="amount-input-wrapper">
                      <span className="currency-symbol">₹</span>
                      <input
                        type="tel"
                        id="amountInput"
                        className="main-amount-input"
                        placeholder="0"
                        value={global}
                        onChange={(e) => {
                          const val = e.target.value;
                          val > 0
                            ? val <= 100000
                              ? setGlobal(parseInt(val))
                              : setGlobal(50000)
                            : val < 0
                              ? setGlobal(10)
                              : setGlobal(0);
                        }}
                      />
                    </div>
                    <p className="limit-hint">
                      Min: <span>₹{minLimit}</span> • Max:{" "}
                      <span>₹{maxLimit}</span>
                    </p>

                    {/* Quick Select Chips */}
                    <div className="quick-chips-grid">
                      {[300, 500, 1000, 2000].map((amt) => (
                        <button
                          key={amt}
                          className={`chip-btn ${global === amt ? "active" : ""}`}
                          onClick={() => setGlobal(amt)}
                        >
                          <img
                            src="/images/rupee-coin.png"
                            alt="coin"
                            className="chip-icon"
                          />
                          <span>+{amt}</span>
                        </button>
                      ))}
                    </div>

                    {/* Action Button Section */}
                    <div className="action-footer mt-4">
                      {addCaseSetting.isDeposit ? (
                        <button
                          type="button"
                          className="proceed-btn"
                          onClick={() => {
                            if (!global || global <= 0) {
                              Swal.fire({
                                icon: "warning",
                                title: "Invalid Amount",
                                text: "Please enter a valid amount",
                              });
                              return;
                            }
                            if (global % 100 !== 0) {
                              Swal.fire({
                                icon: "error",
                                title: "Invalid Amount",
                                text: "👉 कृपया payment 100, 200, 300, 400, 500 के क्रम में ही दर्ज करें 👈",
                              });
                              return;
                            }
                            if (global > 100000) {
                              Swal.fire({
                                icon: "warning",
                                title: "Limit Exceeded",
                                text: "Maximum allowed amount is 100000",
                              });
                              return;
                            }
                            handleNext();
                          }}
                        >
                          Proceed to Pay
                        </button>
                      ) : (
                        <div className="service-closed-msg">
                          <i className="fa fa-clock-o"></i>
                          Deposit services closed for some time
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              )}

              {Boolean(next == 2) && (
                <div className="">
                  <>
                    <div className="pb-3">
                      <div className={`${css.games_section}`}>
                        <div className="d-flex position-relative align-items-center justify-content-between">
                          <div className="add_cash_small_haedings">
                            Amount to be added ₹<b>{global}</b>
                          </div>

                          <button
                            type="button"
                            onClick={() => setNext(1)}
                            className="samll_btn"
                          >
                            Edit
                          </button>
                        </div>
                      </div>
                    </div>

                    <div className="mt-1">
                      {/* <div className="profile_headings">
                        Pay Through QR CODE
                      </div> */}

                      {/* PHONE pay  */}
                      {/* {Boolean(isPhonePayActive) && (
                        <div
                          onClick={() => fetchPaymentUrl()}
                          className="add-fund-box mt-3"
                          style={{ paddingTop: "0px", height: "60px" }}
                        >
                          {isLoading ? (
                            <div
                              className="loaderReturn"
                              style={{ zIndex: "99" }}
                            >
                              <img
                                src={"/images/LandingPage_img/loader1.gif"}
                                style={{ width: "100%" }}
                              />
                            </div>
                          ) : (
                            <div
                              className="d-flex align-items-center"
                              style={{
                                backgroundColor: "#fafafa",
                                border: "1px solid #e0e0e0",
                                borderRadius: "7px",
                              }}
                            >
                              <div
                                className="d-flex align-items-center"
                                style={{
                                  height: "60px",
                                  display: "flex",
                                  textAlign: "center",
                                }}
                              >
                                <img
                                  width="40px"
                                  src="/UPI.png"
                                  alt=""
                                  style={{
                                    marginLeft: "7px",
                                    paddingBottom: "10px",
                                    paddingLeft: "3px",
                                    paddingTop: "5px",
                                  }}
                                />
                              </div>
                              <div className="d-flex justify-content-center flex-column ml-4">
                                <div className="jss30">
                                  <strong>Pay Now 1</strong>
                                </div>
                                <div className="jss31"></div>
                              </div>
                            </div>
                          )}
                        </div>
                      )} */}

                      {/* pg-upigateway */}

                      {global >= manualData?.gatewayRangemin &&
                        Boolean(isUpiGateway) &&
                        global <= manualData?.gatewayRangemax && (
                          <>
                            <div className="gameCard">
                              <div className="alrt_msg_div">
                                <h5 className="">
                                  1.👉 नीचे Paynow के ऑप्शन पर क्लिक करें |{" "}
                                  <br />
                                  2.👉 अब आपको एक QR कोड दिखाई देगा अब इस QR कोड
                                  का स्क्रीनशॉट लेकर पेमेंट कर दे ! आपका पेमेंट
                                  1 मिनट में ऑटोमेटिक अपडेट हो जाएगा | <br />
                                  3.नोट 👉बारकोड जेनरेट होने के बाद बैक बटन और
                                  रिफ्रेश बटन न दबाएं |
                                </h5>
                              </div>
                            </div>
                            <div
                              onClick={() => upigateway()}
                              className="add-fund-box mt-3"
                              style={{ paddingTop: "0px", height: "60px" }}
                            >
                              {isLoading ? (
                                <div
                                  className="loaderReturn"
                                  style={{ zIndex: "99" }}
                                >
                                  <img
                                    src={"/images/LandingPage_img/loader1.gif"}
                                    style={{ width: "100%" }}
                                  />
                                </div>
                              ) : (
                                <div
                                  className="d-flex align-items-center"
                                  style={{
                                    backgroundColor: "#fafafa",
                                    border: "1px solid #e0e0e0",
                                    borderRadius: "7px",
                                  }}
                                >
                                  <div
                                    className="d-flex align-items-center"
                                    style={{
                                      height: "60px",
                                      display: "flex",
                                      textAlign: "center",
                                    }}
                                  >
                                    <img
                                      width="40px"
                                      src="/UPI.png"
                                      alt=""
                                      style={{
                                        marginLeft: "7px",
                                        paddingBottom: "10px",
                                        paddingLeft: "3px",
                                        paddingTop: "5px",
                                      }}
                                    />
                                  </div>
                                  <div className="d-flex justify-content-center flex-column ml-4">
                                    <div className="jss30">
                                      <strong>pg-upigateway </strong>
                                    </div>
                                    <div className="jss31"></div>
                                  </div>
                                </div>
                              )}
                            </div>
                          </>
                        )}

                      {/*mypay pay  */}

                      {/* {global < 2001 ? */}
                      {Boolean(isMypayInActive) && (
                        <div
                          onClick={() => myPay()}
                          className="add-fund-box mt-3"
                          style={{ paddingTop: "0px", height: "60px" }}
                        >
                          {isLoading ? (
                            <div
                              className="loaderReturn"
                              style={{ zIndex: "99" }}
                            >
                              <img
                                src={"/images/LandingPage_img/loader1.gif"}
                                style={{ width: "100%" }}
                              />
                            </div>
                          ) : (
                            <div
                              className="d-flex align-items-center"
                              style={{
                                backgroundColor: "#fafafa",
                                border: "1px solid #e0e0e0",
                                borderRadius: "7px",
                              }}
                            >
                              <div
                                className="d-flex align-items-center"
                                style={{
                                  height: "60px",
                                  display: "flex",
                                  textAlign: "center",
                                }}
                              >
                                <img
                                  width="40px"
                                  src="/UPI.png"
                                  alt=""
                                  style={{
                                    marginLeft: "7px",
                                    paddingBottom: "10px",
                                    paddingLeft: "3px",
                                    paddingTop: "5px",
                                  }}
                                />
                              </div>
                              <div className="d-flex justify-content-center flex-column ml-4">
                                <div className="jss30">
                                  <strong>Pay Now 2</strong>
                                </div>
                                <div className="jss31"></div>
                              </div>
                            </div>
                          )}
                        </div>
                      )}
                      {global >= manualData?.acRangemin &&
                        Boolean(AcDeposit) &&
                        global <= manualData?.acRangemax && (
                          <div>
                            {addCaseSetting?.supportTelegram != "" ? (
                              <>
                                <span class="text-left font-weight-bold">
                                  पेमेंट Add कैसे करे |
                                </span>
                                <div>
                                  <iframe
                                    className="mt-1 i-frame-video"
                                    src={addCaseSetting?.supportTelegram}
                                    title="How To Add Money"
                                    height="200px !important"
                                    width="100% !important"
                                  ></iframe>
                                </div>
                              </>
                            ) : (
                              ""
                            )}
                            <div class="alrt_msg_div">
                              <h5 class="">
                                {addCaseSetting?.ludoClassicAutobattleMsg}
                              </h5>
                            </div>
                            <div class="text-center mt-1">
                              <h4>Payment Amount</h4>
                              <h5 class="text-danger">₹ {global}</h5>
                              <div class="form-group position-relative">
                                <label for="paymentMethod">
                                  Payment Method{" "}
                                </label>

                                <select
                                  id="paymentMethod"
                                  class="form-control custom-select-1"
                                  value={paymentMethod}
                                  onChange={handlePaymentMethodChange}
                                >
                                  <option value="Selectoption">
                                    Select Payment Option
                                  </option>
                                  <option value="UPI">UPI</option>
                                  <option value="Account">Account</option>
                                </select>
                              </div>
                              <div>
                                {nextStep === 7 && (
                                  <>
                                    <div class="d-flex justify-content-between align-items-center border border-1 p-2 mb-3 rounded">
                                      <p class="mb-0">UPI ID:</p>
                                      <p class="mb-0 text-danger">
                                        {manualData?.upiIdAccount}
                                      </p>
                                      <div
                                        class="btn btn-primary text-light py-2 px-3"
                                        onClick={(e) => copyUpiAc(e)}
                                      >
                                        Copy
                                      </div>
                                    </div>
                                  </>
                                )}
                                {/* <img  src={baseUrl + manualData.isPayTwoImage}  style={{width:"100px", height:"100px"}}/> */}

                                {nextStep === 6 && (
                                  <>
                                    <div class="d-flex justify-content-between align-items-center border border-1 p-2 mb-3 rounded">
                                      <p class="mb-0">Bank Name:</p>
                                      <p class="mb-0 text-danger">
                                        {manualData?.BankName}
                                      </p>
                                      <div
                                        class="btn btn-primary text-light py-2 px-3"
                                        onClick={copyBank}
                                      >
                                        Copy
                                      </div>
                                    </div>
                                    <div class="d-flex justify-content-between align-items-center border border-1 p-2 mb-3 rounded">
                                      <p class="mb-0">Account Number:</p>
                                      <p class="mb-0 text-danger">
                                        {manualData?.acNO}
                                      </p>
                                      <div
                                        class="btn btn-primary text-light py-2 px-3"
                                        onClick={copyAcNo}
                                      >
                                        Copy
                                      </div>
                                    </div>
                                    <div class="d-flex justify-content-between align-items-center border border-1 p-2 mb-3 rounded">
                                      <p class="mb-0">Beneficiary Name:</p>
                                      <p class="mb-0 text-danger">
                                        {manualData?.holderName}
                                      </p>
                                      <div
                                        class="btn btn-primary text-light py-2 px-3"
                                        onClick={copyAcName}
                                      >
                                        Copy
                                      </div>
                                    </div>
                                    <div class="d-flex justify-content-between align-items-center border border-1 p-2 rounded">
                                      <p class="mb-0">IFSC Code:</p>
                                      <p class="mb-0 text-danger">
                                        {manualData?.IFSC}
                                      </p>
                                      <div
                                        class="btn btn-primary text-light py-2 px-3"
                                        onClick={copyIFSC}
                                      >
                                        Copy
                                      </div>
                                    </div>
                                  </>
                                )}
                              </div>
                            </div>
                            <div class="text-left mt-3">
                              <div class="mt-3">
                                <label for="utrNumber" class="mt-2">
                                  Enter UTR Number
                                </label>
                                <input
                                  type="number"
                                  id="utrNumber"
                                  class="form-control"
                                  onChange={(e) => setutr(e.target.value)}
                                />
                              </div>
                              <div class="mt-3 ">
                                <label for="utrNumber" class="mt-2">
                                  Upload Payment Screenshot
                                </label>
                                <input
                                  type="file"
                                  className="border p-1 rounded w-100"
                                  onChange={handleChange}
                                  accept="image/*"
                                  required
                                />
                              </div>
                              <div class="d-flex justify-content-center mt-4">
                                <div
                                  class="btn btn-primary text-light py-2 px-3"
                                  onClick={AccountPayment}
                                >
                                  Confirm
                                </div>
                              </div>
                            </div>
                            <div class="alrt_msg_div">
                              <h5
                                class=""
                                style={{
                                  fontSize: "1.7rem",
                                  lineHeight: "30px",
                                }}
                              >
                                ⛔किसी भी Usre को Account में Deposit करने में
                                कोई भी समस्या आए तो यहां पर
                                <a
                                  class="btn btn-primary text-light py-2 px-3 mx-2"
                                  href={`https://wa.me/+91${addCaseSetting?.ludoClassicManualBattleMsg}`}
                                >
                                  {" "}
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="16"
                                    height="16"
                                    fill="currentColor"
                                    class="bi bi-whatsapp"
                                    viewBox="0 0 16 16"
                                  >
                                    <path d="M13.601 2.326A7.85 7.85 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.9 7.9 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.9 7.9 0 0 0 13.6 2.326zM7.994 14.521a6.6 6.6 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.56 6.56 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592m3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.73.73 0 0 0-.529.247c-.182.198-.691.677-.691 1.654s.71 1.916.81 2.049c.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232" />
                                  </svg>
                                  संपर्क करें{" "}
                                </a>
                              </h5>
                            </div>
                          </div>
                        )}

                      {
                        // sabpay
                        Boolean(isSubPaisaActive) && (
                          <div
                            onClick={() => fetchPaymentUrl2()}
                            className="add-fund-box mt-3"
                            style={{ paddingTop: "0px", height: "60px" }}
                          >
                            {isLoading ? (
                              <div
                                className="loaderReturn"
                                style={{ zIndex: "99" }}
                              >
                                <img
                                  src={"/images/LandingPage_img/loader1.gif"}
                                  style={{ width: "100%" }}
                                />
                              </div>
                            ) : (
                              <div
                                className="d-flex align-items-center"
                                style={{
                                  backgroundColor: "#fafafa",
                                  border: "1px solid #e0e0e0",
                                  borderRadius: "7px",
                                }}
                              >
                                <div
                                  className="d-flex align-items-center"
                                  style={{
                                    height: "60px",
                                    display: "flex",
                                    textAlign: "center",
                                  }}
                                >
                                  <img
                                    width="40px"
                                    src="/UPI.png"
                                    alt=""
                                    style={{
                                      marginLeft: "7px",
                                      paddingBottom: "10px",
                                      paddingLeft: "3px",
                                      paddingTop: "5px",
                                    }}
                                  />
                                </div>
                                <div className="d-flex justify-content-center flex-column ml-4">
                                  <div className="jss30">
                                    <strong>Pay Now 3</strong>
                                  </div>
                                  <div className="jss31"></div>
                                </div>
                              </div>
                            )}
                          </div>
                        )
                      }
                      {/* } */}

                      <div className="Qrcode">
                        {/* Qr code 1 */}
                        {global >= manualData?.upiRangemin &&
                          Boolean(manualData?.isPayNowOne) &&
                          global <= manualData?.upiRangemax && (
                            <>
                              {/* <div class="alrt_msg_div">
                              <h5 class="">
                                {addCaseSetting?.ludoClassicAutobattleMsg}
                              </h5>
                            </div> */}

                              <div class="text-center mt-1">
                                <h4>Payment Amount</h4>
                                <h5 class="text-danger">₹ {global}</h5>
                                <div class="form-group position-relative">
                                  <label for="paymentMethod">
                                    Payment Method
                                  </label>

                                  <select
                                    id="paymentMethod"
                                    class="form-control custom-select-1"
                                    value={paymentMethod}
                                    onChange={handlePaymentMethodChange}
                                  >
                                    <option value="Selectoption">
                                      Select Payment Option
                                    </option>
                                    <option value="UPI">UPI</option>
                                    <option value="Account">Account</option>
                                  </select>
                                </div>
                                <div>
                                  {nextStep === 7 && (
                                    <>
                                      <div class="d-flex justify-content-between align-items-center border border-1 p-2 mb-3 rounded">
                                        <p class="mb-0">UPI ID:</p>
                                        <p class="mb-0 text-danger">
                                          {manualData?.isPayOneUpi}
                                        </p>
                                        <div
                                          class="btn btn-primary text-light py-2 px-3"
                                          onClick={() =>
                                            copyButton(manualData?.isPayOneUpi)
                                          }
                                        >
                                          Copy
                                        </div>
                                      </div>
                                    </>
                                  )}
                                  {/* <img  src={baseUrl + manualData.isPayTwoImage}  style={{width:"100px", height:"100px"}}/> */}

                                  {nextStep === 6 && (
                                    <>
                                      <div class="d-flex justify-content-between align-items-center border border-1 p-2 mb-3 rounded">
                                        <p class="mb-0">Bank Name:</p>
                                        <p class="mb-0 text-danger">
                                          {manualData?.BankName1}
                                        </p>
                                        <div
                                          class="btn btn-primary text-light py-2 px-3"
                                          onClick={() =>
                                            copyButton(manualData?.BankName1)
                                          }
                                        >
                                          Copy
                                        </div>
                                      </div>
                                      <div class="d-flex justify-content-between align-items-center border border-1 p-2 mb-3 rounded">
                                        <p class="mb-0">Account Number:</p>
                                        <p class="mb-0 text-danger">
                                          {manualData?.acNO1}
                                        </p>
                                        <div
                                          class="btn btn-primary text-light py-2 px-3"
                                          onClick={() =>
                                            copyButton(manualData?.acNO1)
                                          }
                                        >
                                          Copy
                                        </div>
                                      </div>
                                      <div class="d-flex justify-content-between align-items-center border border-1 p-2 mb-3 rounded">
                                        <p class="mb-0">Beneficiary Name:</p>
                                        <p class="mb-0 text-danger">
                                          {manualData?.holderName1}
                                        </p>
                                        <div
                                          class="btn btn-primary text-light py-2 px-3"
                                          onClick={() =>
                                            copyButton(manualData?.holderName1)
                                          }
                                        >
                                          Copy
                                        </div>
                                      </div>
                                      <div class="d-flex justify-content-between align-items-center border border-1 p-2 rounded">
                                        <p class="mb-0">IFSC Code:</p>
                                        <p class="mb-0 text-danger">
                                          {manualData?.IFSC1}
                                        </p>
                                        <div
                                          class="btn btn-primary text-light py-2 px-3"
                                          onClick={() =>
                                            copyButton(manualData?.IFSC1)
                                          }
                                        >
                                          Copy
                                        </div>
                                      </div>
                                    </>
                                  )}
                                </div>
                              </div>

                              {/* <div class="alrt_msg_div">
                              <h5 class="" style={{ fontSize: "1.1rem", lineHeight: "30px" }}>
                                ⛔Deposit add करने के लिए नीचे WhatsApp पर संपर्क करें  👇👇
                              </h5>
                            </div>
                            <div className="d-whatsaap-page">
                              <a class="btn btn-success text-light f-flex" href={`https://wa.me/+91${addCaseSetting?.ludoClassicManualBattleMsg}`}> <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" fill="currentColor" class="bi bi-whatsapp " viewBox="0 0 16 16">
                                <path d="M13.601 2.326A7.85 7.85 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.9 7.9 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.9 7.9 0 0 0 13.6 2.326zM7.994 14.521a6.6 6.6 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.56 6.56 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592m3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.73.73 0 0 0-.529.247c-.182.198-.691.677-.691 1.654s.71 1.916.81 2.049c.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232" />
                              </svg> </a>
                            </div> */}
                              <div
                                className="d-flex align-items-center justify-content-center"
                                style={{ margin: "auto" }}
                              >
                                <button
                                  className="results_btn results_btn_win mt-2"
                                  onClick={handleShow_won}
                                >
                                  {" "}
                                  Upload Payment Details
                                </button>
                              </div>
                            </>
                          )}

                        {/* Qr code 1 */}
                        {global >= manualData?.whatsappRangemin &&
                          Boolean(manualData?.whatsappDeposit) &&
                          global <= manualData?.whatsappRangemax && (
                            <>
                              {/* <div class="alrt_msg_div">
                              <h5 class="">
                                {addCaseSetting?.ludoClassicAutobattleMsg}
                              </h5>
                            </div> */}

                              <div class="text-center mt-1">
                                <h4>Payment Amount</h4>
                                <h5 class="text-danger">₹ {global}</h5>
                                <div class="form-group position-relative">
                                  <label for="paymentMethod">
                                    Payment Method
                                  </label>
                                </div>
                              </div>
                              <div class="alrt_msg_div">
                                <h5
                                  class=""
                                  style={{
                                    fontSize: "1.1rem",
                                    lineHeight: "30px",
                                  }}
                                >
                                  ⛔Deposit add करने के लिए नीचे WhatsApp पर
                                  संपर्क करें  👇👇
                                </h5>
                              </div>
                              <div className="d-whatsaap-page">
                                <a
                                  class="btn  text-light f-flex"
                                  // href={`https://wa.me/+91${addCaseSetting?.ludoClassicManualBattleMsg}`}
                                  href={addCaseSetting?.whatsappSupport}
                                >
                                  {" "}
                                  {/* <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="50"
                                    height="50"
                                    fill="currentColor"
                                    class="bi bi-whatsapp "
                                    viewBox="0 0 16 16"
                                  >
                                    <path d="M13.601 2.326A7.85 7.85 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.9 7.9 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.9 7.9 0 0 0 13.6 2.326zM7.994 14.521a6.6 6.6 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.56 6.56 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592m3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.73.73 0 0 0-.529.247c-.182.198-.691.677-.691 1.654s.71 1.916.81 2.049c.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232" />
                                  </svg>{" "} */}
                                  <img
                                    src="images/whatsapp.png"
                                    style={{ width: 50, height: 50 }}
                                  />

                                </a>
                              </div>
                              <div
                                className="d-flex align-items-center justify-content-center"
                                style={{ margin: "auto", marginTop: "28px" }}
                              >
                                <button
                                  className="results_btn results_btn_win mt-2"
                                  onClick={handleShow_won}
                                >
                                  {" "}
                                  Upload Payment Details
                                </button>
                              </div>
                            </>
                          )}

                        {global >= manualData?.qrRangemin &&
                          Boolean(manualData?.isPayNowTwo) &&
                          global <= manualData?.qrRangemax && (
                            <>
                              <div class="alrt_msg_div">
                                <h5 class="">
                                  {addCaseSetting?.ludoClassicAutobattleMsg}
                                </h5>
                              </div>
                              <h4 className="mt-4">
                                नीचे दी हुई Upi Or QR पर भुगतान करें |
                              </h4>
                              <div class="d-flex justify-content-between align-items-center border border-1 p-2 mb-3 rounded">
                                <p class="mb-0">UPI ID:</p>
                                <p class="mb-0 text-danger">
                                  {manualData?.isPayTwoUpi}
                                </p>
                                <div
                                  class="btn btn-primary text-light py-2 px-3"
                                  onClick={(e) => copyUpi(e)}
                                >
                                  Copy
                                </div>
                              </div>
                              <img
                                src={baseUrl + manualData.isPayTwoImage} // Replace with the actual path to your image file
                                alt="QR Image"
                                style={{
                                  width: "50%",

                                  display: "block",
                                  margin: "auto",
                                }}
                              />

                              <div className="d-flex align-items-center justify-content-center">
                                <button
                                  className="results_btn results_btn_win mt-2"
                                  onClick={handleShow_won}
                                >
                                  {" "}
                                  Upload Payment Details
                                </button>
                              </div>
                            </>
                          )}

                        {/* Qr code 3 */}
                        {manualData?.isPayNowThree ? (
                          <div
                            onClick={() => {
                              setNext(3);
                              getImageUrl(PayThreeImage, PayNow3Url);
                            }}
                            // onClick={() => fetchPaymentUrl()}
                            className="add-fund-box mt-3"
                            style={{ paddingTop: "0px", height: "60px" }}
                          >
                            {isLoading ? (
                              <div
                                className="loaderReturn"
                                style={{ zIndex: "99" }}
                              >
                                <img
                                  src={"/images/LandingPage_img/loader1.gif"}
                                  style={{ width: "100%" }}
                                />
                              </div>
                            ) : (
                              <div
                                className="d-flex align-items-center"
                                style={{
                                  backgroundColor: "#fafafa",
                                  border: "1px solid #e0e0e0",
                                  borderRadius: "7px",
                                }}
                              >
                                <div
                                  className="d-flex align-items-center"
                                  style={{
                                    height: "60px",
                                    display: "flex",
                                    textAlign: "center",
                                  }}
                                >
                                  <img
                                    width="40px"
                                    src="/UPI.png"
                                    alt=""
                                    style={{
                                      marginLeft: "7px",
                                      paddingBottom: "10px",
                                      paddingLeft: "3px",
                                      paddingTop: "5px",
                                    }}
                                  />
                                </div>
                                <div className="d-flex justify-content-center flex-column ml-4">
                                  <div className="jss30">
                                    <strong>QR CODE 3</strong>
                                  </div>
                                  <div className="jss31"></div>
                                </div>
                              </div>
                            )}
                          </div>
                        ) : (
                          ""
                        )}

                        {/* Qr code 4 */}
                        {manualData?.isPayNowFour ? (
                          <div
                            onClick={() => {
                              setNext(3);
                              getImageUrl(PayFourImage, PayNow4Url);
                            }}
                            // onClick={() => fetchPaymentUrl()}
                            className="add-fund-box mt-3"
                            style={{ paddingTop: "0px", height: "60px" }}
                          >
                            {isLoading ? (
                              <div
                                className="loaderReturn"
                                style={{ zIndex: "99" }}
                              >
                                <img
                                  src={"/images/LandingPage_img/loader1.gif"}
                                  style={{ width: "100%" }}
                                />
                              </div>
                            ) : (
                              <div
                                className="d-flex align-items-center"
                                style={{
                                  backgroundColor: "#fafafa",
                                  border: "1px solid #e0e0e0",
                                  borderRadius: "7px",
                                }}
                              >
                                <div
                                  className="d-flex align-items-center"
                                  style={{
                                    height: "60px",
                                    display: "flex",
                                    textAlign: "center",
                                  }}
                                >
                                  <img
                                    width="40px"
                                    src="/UPI.png"
                                    alt=""
                                    style={{
                                      marginLeft: "7px",
                                      paddingBottom: "10px",
                                      paddingLeft: "3px",
                                      paddingTop: "5px",
                                    }}
                                  />
                                </div>
                                <div className="d-flex justify-content-center flex-column ml-4">
                                  <div className="jss30">
                                    <strong>QR CODE 4</strong>
                                  </div>
                                  <div className="jss31"></div>
                                </div>
                              </div>
                            )}
                          </div>
                        ) : (
                          ""
                        )}

                        {/* Qr code 5 */}
                        {manualData?.isPayNowFive ? (
                          <div
                            onClick={() => {
                              setNext(3);
                              getImageUrl(PayFiveImage, PayNow5Url);
                            }}
                            className="add-fund-box mt-3"
                            style={{ paddingTop: "0px", height: "60px" }}
                          >
                            {isLoading ? (
                              <div
                                className="loaderReturn"
                                style={{ zIndex: "99" }}
                              >
                                <img
                                  src={"/images/LandingPage_img/loader1.gif"}
                                  style={{ width: "100%" }}
                                />
                              </div>
                            ) : (
                              <div
                                className="d-flex align-items-center"
                                style={{
                                  backgroundColor: "#fafafa",
                                  border: "1px solid #e0e0e0",
                                  borderRadius: "7px",
                                }}
                              >
                                <div
                                  className="d-flex align-items-center"
                                  style={{
                                    height: "60px",
                                    display: "flex",
                                    textAlign: "center",
                                  }}
                                >
                                  <img
                                    width="40px"
                                    src="/UPI.png"
                                    alt=""
                                    style={{
                                      marginLeft: "7px",
                                      paddingBottom: "10px",
                                      paddingLeft: "3px",
                                      paddingTop: "5px",
                                    }}
                                  />
                                </div>
                                <div className="d-flex justify-content-center flex-column ml-4">
                                  <div className="jss30">
                                    <strong>QR CODE 5</strong>
                                  </div>
                                  <div className="jss31"></div>
                                </div>
                              </div>
                            )}
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  </>
                </div>
              )}
            </div>
          )}
          {Boolean(next == 3) && (
            <>
              {/* <div class="alrt_msg_div">
                    <h5 class="">
                      अगर कोई यूजर मैन्युअल डिपॉजिट अमाउंट जितना पे करता है उतना
                      ही पेमेंट डालकर UTR नंबर और स्क्रीनशॉट सबमिट करें अगर आप
                      पेमेंट कम या और ज्यादा डालते हो आपका किया हुआ
                      डिपॉजिट ऐड नहीं होगा |
                    </h5>
                  </div> */}
              <h4 className="mt-4">नीचे दी हुई UPI या QR पर भुगतान करें |</h4>
              <img
                src={baseUrl + manualData.isPayOneImage} // Replace with the actual path to your image file
                alt="QR Image"
                style={{
                  width: "90%",
                  height: "10%",
                  display: "block",
                  margin: "auto",
                }}
              />
              {/* <div>
                    <DownloadLink
                      className="results_btn results_btn_cancel mt-3"
                      style={{ width: "50%" }}
                      label=" Download QR"
                      filename={baseUrl + `${ImageUrl}`}
                      exportFile={() => "My cached data"}
                    />
                  </div> */}

              <div className="Refer_code">
                <h3>{manualData?.isPayOneUpi}</h3>

                <button onClick={(e) => copyCode(e)}>Copy</button>
              </div>

              <div>
                <button
                  className="results_btn results_btn_win mt-2"
                  onClick={handleShow_won}
                >
                  {" "}
                  Upload Payment Details
                </button>
              </div>
            </>
          )}

          {Boolean(process1) && (
            <div className="loaderReturn" style={{ zIndex: "99" }}>
              <img
                src={"/images/LandingPage_img/loader1.gif"}
                style={{ width: "100%" }}
              />
            </div>
          )}
        </div>
      </div>

      <section className="win_modal">
        <Modal
          show={show_won}
          onHide={handleClose_won}
          className="cancel_popup_reason_popup"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Header closeButton></Modal.Header>
          <Modal.Body>
            <div>
              <h3>Payment Details</h3>
              <div>
                <lable className="commaon_label">AMOUNT</lable>
                <input
                  className="commaon_input_box mb-2"
                  type="number"
                  required
                  value={global}
                  onChange={(e) => setGlobal(e.target.value)}
                  placeholder="Enter amount"
                  readOnly
                />
                <lable className="commaon_label mt-4">UTR NUMBER</lable>
                <input
                  className="commaon_input_box"
                  type="text"
                  required
                  value={utr}
                  onChange={(e) => setutr(e.target.value)}
                  placeholder="Enter UTR Number"
                />
              </div>

              <div className={`${css1.doc_upload} mt-4 upload_ss_btn`}>
                <input
                  type="file"
                  onChange={handleChange}
                  accept="image/*"
                  required
                />
                {!scrnshot && (
                  <div className="cxy flex-column position-absolute ">
                    <i
                      className="fa-solid fa-arrow-up"
                      style={{ color: "#fff" }}
                    ></i>
                    <div
                      className={`${css1.sideNav_text} mt-2 upload_ss_btn_name`}
                    >
                      Upload screenshot.
                    </div>
                  </div>
                )}
                {scrnshot && (
                  <div className={css1.uploaded}>
                    <img
                      src="/images/file-icon.png"
                      width="26px"
                      alt=""
                      style={{ marginRight: "20px" }}
                    />
                    <div
                      className="d-flex flex-column"
                      style={{ width: "80%" }}
                    >
                      <div
                        className={`${css1.name} `}
                        style={{ color: "#fff" }}
                      >
                        {scrnshot.name}
                      </div>
                      <div className={css1.size}>
                        {(scrnshot.size / 1024 / 1024).toFixed(2)} MB
                      </div>
                    </div>
                    <div className="image-block">
                      <img
                        src="/images/global-cross.png"
                        width="10px"
                        alt=""
                        onClick={() => {
                          clearImage();
                          handleClose_won();
                        }}
                      />
                    </div>
                  </div>
                )}
              </div>

              <div style={{ width: "100%", marginTop: "20px" }}>
                <img
                  src={scrnshot1}
                  style={{ width: "100%" }}
                  className="screenshot_img"
                />
              </div>

              {/* {fecthStatus == null && fecthStatus == undefined && (
                <input
                  type="submit"
                  value="Submit"
                  className="btn btn-danger mt-3 text-white results_btn w-100"
                  id="post"
                  // onClick={(e) => {
                  //   Result(e);
                  // }}
                  onClick={ManualPayments}
                  disabled={!scrnshot}
                />
              )} */}

              {fecthStatus == null && fecthStatus == undefined && (
                <>
                  {isLoading1 ? (
                    <button className="Login-button cxy" disabled>
                      <Spinner
                        as="span"
                        animation="grow"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                      />
                      Loading...
                    </button>
                  ) : (
                    <input
                      type="submit"
                      value="Submit"
                      className="btn btn-danger mt-3 text-white results_btn w-100"
                      id="post"
                      onClick={ManualPayments}
                      disabled={!scrnshot}
                    />
                  )}
                </>
              )}
            </div>
          </Modal.Body>
        </Modal>
      </section>

      <div className="rightContainer">
        <Rightcontainer />
      </div>
    </>
  );
};

export default Addcase;
